import styled, { css, DefaultTheme } from 'styled-components'
import { ProcedurePendencyCardProps } from '.'

export const CardWrapper = styled.div`
  width: auto;
  height: auto;
  border: 1px solid #82cec9;
  border-radius: 16px;
  margin: auto;
  display: block;
  padding: 24px 40px;
  margin-bottom: 20px;
`

export type ContainerProps = Pick<
  ProcedurePendencyCardProps,
  'variant' | 'selected'
>

const variants = {
  orange: (theme: DefaultTheme, selected?: boolean) => css`
    .header_container {
      label {
        svg,
        path {
          fill: ${theme.ds.colors.terciary400};
        }
      }
    }

    .pendency_info {
      strong {
        color: ${theme.ds.colors.terciary800};
      }
    }

    .comment_container {
      border-left: 1px solid ${({ theme }) => theme.ds.colors.terciary200};
    }

    .status_tag {
      background: ${theme.ds.colors.terciary100};

      span {
        color: ${theme.ds.colors.terciary900};
        width: max-content;
      }
    }

    ${selected &&
    css`
      background-color: ${theme.ds.colors.terciary25};
    `}
  `,

  purple: (theme: DefaultTheme, selected?: boolean) => css`
    .header_container {
      label {
        svg,
        path {
          fill: ${theme.ds.colors.secondary400};
        }
      }
    }

    .pendency_info {
      strong {
        color: ${theme.ds.colors.secondary800};
      }
    }

    .comment_container {
      border-left: 1px solid ${({ theme }) => theme.ds.colors.secondary200};
    }

    .status_tag {
      background: ${theme.ds.colors.secondary100};

      span {
        color: ${theme.ds.colors.secondary900};
      }
    }

    ${selected &&
    css`
      background-color: ${theme.ds.colors.secondary25};
    `}
  `,

  green: (theme: DefaultTheme, selected?: boolean) => css`
    .header_container {
      label {
        svg,
        path {
          fill: ${theme.ds.colors.primary400};
        }
      }
    }

    .pendency_info {
      strong {
        color: ${theme.ds.colors.primary800};
      }
    }

    .comment_container {
      border-left: 1px solid ${({ theme }) => theme.ds.colors.primary200};
    }

    .status_tag {
      background: ${theme.ds.colors.primary100};

      span {
        color: ${theme.ds.colors.primary900};
      }
    }

    ${selected &&
    css`
      background-color: ${theme.ds.colors.primary25};
    `}
  `
} as any

export const CardContainer = styled.div<any>`
  ${({ variant, selected, theme }) => css`
    width: auto;
    height: auto;
    border-radius: 8px;
    display: block;
    padding: 16px;

    box-shadow: 0px 1px 3px 1px rgba(0, 0, 0, 0.12),
      0px 1px 2px rgba(0, 0, 0, 0.24);

    cursor: pointer;

    .header_container {
      display: flex;
      justify-content: space-between;
      align-items: center;

      label {
        display: flex;
        font-weight: ${({ theme }) => theme.ds.typography.weight.semiBold};
        font-size: ${({ theme }) => theme.ds.typography.size.small};
        color: ${({ theme }) => theme.ds.colors.neutral900};
        margin-right: 2px;
        svg {
          margin-right: 8px;
        }
      }
    }

    h2 {
      font-size: ${({ theme }) => theme.font.sizes.xsmall};
      color: ${({ theme }) => theme.ds.colors.neutral800};
      font-weight: ${({ theme }) => theme.ds.typography.weight.normal};
    }

    .comment_container {
      border-left: 1px solid ${({ theme }) => theme.ds.colors.neutral200};
      padding: 4px 16px;
      align-items: center;
      margin: 16px 0;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      line-height: 1.3;
      min-height: 2.6em;

      span {
        font-size: ${({ theme }) => theme.font.sizes.xsmall};
        color: ${({ theme }) => theme.ds.colors.neutral600};
        font-weight: ${({ theme }) => theme.ds.typography.weight.normal};
      }
    }

    .pendency_info {
      display: flex;
      flex-direction: column;
      gap: 8px;

      strong {
        color: #000;
        font-size: ${({ theme }) => theme.ds.typography.size.xsmall};
        font-weight: ${({ theme }) => theme.ds.typography.weight.bold};
        color: ${({ theme }) => theme.ds.colors.neutral900};
      }

      p {
        color: ${({ theme }) => theme.ds.colors.neutral600};
        font-size: ${({ theme }) => theme.ds.typography.size.xsmall};
        font-weight: ${({ theme }) => theme.ds.typography.weight.normal};
      }
    }

    .status_tag {
      width: auto;
      height: auto;
      margin: 0;
      padding: 0 2px;
      display: flex;
      justify-content: center;
      border-radius: 24px;
      display: flex;
      align-items: center;
      gap: 4px;
      background: transparent;

      span {
        font-style: normal;
        font-weight: ${({ theme }) => theme.ds.typography.weight.semiBold};
        font-size: ${({ theme }) => theme.ds.typography.size.xsmall};
        line-height: 28px;
        display: flex;
        align-items: center;
        text-align: center;
        padding: 0 5px;
      }
    }

    ${selected &&
    css`
      box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.24),
        0px 4px 8px 3px rgba(0, 0, 0, 0.12);
    `}

    ${variant && variants[variant](theme, selected)}
  `}
`

export const LineDivider = styled.hr`
  height: 0px;
  border: 1px solid #dadee2;
  background: #dadee2;
  margin-top: 12px;
  width: 100%;
  margin-bottom: 12px;
`
